"use strict";

// Module API

function castAny(format, value) {
  return value;
}

module.exports = {
  castAny: castAny
};


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/types/any.js
// module id = 334
// module chunks = 0